var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "47", viewBox: "0 0 48 47", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fillRule: "nonzero", fill: "none" },
      React.createElement("path", { d: "M.373 23.566C.373 10.758 10.94.38 23.973.38c13.032 0 23.599 10.383 23.599 23.186 0 12.808-10.567 23.187-23.6 23.187-13.032 0-23.6-10.386-23.6-23.187z", fill: "#58DBAC" }),
      React.createElement("path", { d: "M34.155 12.797l-11.002 15.54-7.77-6.265a1.99 1.99 0 0 0-2.766.267 1.91 1.91 0 0 0 .274 2.72l9.41 7.593c.427.343.976.495 1.519.422a1.973 1.973 0 0 0 1.342-.812l12.222-17.256a1.916 1.916 0 0 0-.49-2.691 1.99 1.99 0 0 0-2.74.482z", fill: "#FFF" })
    )
  );
});